export const clients = {
	headerChart: {
		total: "Total de clientes",
		label: "durante o período",
		averagePublic: "Público médio",
		filters: {
			label: "Filtros",
			men: "Homens",
			women: "Mulheres",
			others: "Outros",
		},
	},
	averagePublicPerWeekDay: {
		title: "Público médio por dia da semana",
		label: "Valor médio de público por dia da semana durante o período",
		averageTicket: "Ticket Médio",
	},
	clientRecordPerDay: {
		title: "Recorde de público",
		label: "Maiores quantidades de público durante o período",
		none: "Ninguém",
		person: "{{num}} pessoa",
		people: "{{num}} pessoas",
	},
	topClients: {
		title: "TOP Clientes",
		label: "Valor durante o período",
		infoLabel: "Selecione um cliente para ver detalhes.",
	},
	topTables: {
		title: "TOP Mesas",
		label: "Valor durante o período",
		infoLabel: "Selecione uma mesa para ver detalhes.",
	},
};
